import { render, staticRenderFns } from "./CbsUploadRef.vue?vue&type=template&id=10e4d947&"
import script from "./CbsUploadRef.vue?vue&type=script&lang=js&"
export * from "./CbsUploadRef.vue?vue&type=script&lang=js&"
import style0 from "./CbsUploadRef.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports